import {Injectable} from '@angular/core';
import {EvkHttpService, EvkOption, EvkResponseType} from '@evomatik/evk-common';
import {map} from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class EnAutorizacionDiligenciaFormService {

    constructor(
        private http: EvkHttpService
    ) {
    }

    public getDiligenciaConfigForNombre(nombre: any) {
        return this.http.get<EvkResponseType<any>>(`/seaged-diligencias-service/diligencia-config/nombre/${nombre}`).pipe(
            map(response => response.data)
        );
    }

    public getDiligenciaFindNegocio(id: any) {
        return this.http.get<EvkResponseType<any>>(`/seaged-diligencias-service/tarea/negocio-diligencia/${id}`).pipe(
            map(response => response.data)
        );
    }

    public getUsuariosForUnidadOrganizacional(id: any, roles: string[]) {
        return this.http.get<EvkResponseType<EvkOption[]>>(`/seaged-administrador-service/usuario-organizacion/organizacion/${id}/rol/options?roles=${roles}`).pipe(
            map(response => response.data)
        );
    }

    public getOrganizacionesByTipoOrganizacion(idTipoOrganizacion: any) {
        return this.http.get<EvkResponseType<EvkOption[]>>(`/seaged-administrador-service/organizacion/options/by-tipo-organizacion/${idTipoOrganizacion}`).pipe(
            map(response => response.data)
        );
    }

    public getTiposOrganizacionesByOrganizacionOrigenAndTipoConfiguracion(idOrganizacion: any, tipoConfiguracion: any) {
        return this.http.get<EvkResponseType<EvkOption[]>>(`/seaged-administrador-service/tipo-organizacion/options/${idOrganizacion}/${tipoConfiguracion}`).pipe(
            map(response => response.data)
        );
    }


    public getCargosByIdOrganizacion(idOrganizacion) {
        return this.http.get<EvkResponseType<EvkOption[]>>(`/seaged-administrador-service/cargo/options/${idOrganizacion}`).pipe(
            map(response => response.data)
        );
    }

    public getOrganizacionesByCategoria(categoria: EvkOption) {
        return this.http.get<EvkResponseType<EvkOption[]>>(`/seaged-administrador-service/organizacion/in/${categoria.value}/options`).pipe(
            map(response => response.data)
        );
    }

}
